import React, { useState } from 'react';
import Modal from '../Modal';
import s from './index.module.css';
import { expertsActions } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import RadioButton from '../RadioButton';
import Button from '../Button';
import { getChangeExpertReasons, getSenderId } from '../../store/selectors';

const ChangeExpertModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const reasons = useSelector(getChangeExpertReasons);
  const senderId = useSelector(getSenderId);
  const { dialogId } = useSelector((state) => state.meta.user);
  const [selectedValue, setSelectedValue] = useState();
  const [customTextValue, setCustomText] = useState();

  const onRadioChange = (value) => {
    setSelectedValue(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(expertsActions.changeExpert(dialogId, senderId, selectedValue, customTextValue));
    onClose();
  };

  return (
    <Modal
      closeConfig={{
        color: 'black',
        width: 10,
        height: 10,
        className: s.closeButton,
      }}
      className={s.modal}
      onClose={onClose}
    >
      <div className={s.modalBody}>
        <div className={s.title}>Расскажите, почему вы хотите позвать другого эксперта?</div>
        <form onSubmit={handleSubmit}>
          {reasons.map(({ title, id, customText }) => (
            <div key={id}>
              <RadioButton
                className={s.reason}
                value={id}
                name="closeReason"
                theme="noBorderTheme"
                onChange={onRadioChange}
                isChecked={id === selectedValue}
              >
                {title}
              </RadioButton>
              {customText && (
                <textarea
                  onChange={(e) => setCustomText(e.target.value)}
                  value={customTextValue}
                  disabled={selectedValue !== id}
                  className={s.textReason}
                  rows={5}
                />
              )}
            </div>
          ))}
          <Button className={s.submitBtn} type="submit" background="blue" disabled={selectedValue === undefined}>
            Позвать другого эксперта
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default ChangeExpertModal;
